var InMemoryCache = /** @class */function () {
  function InMemoryCache() {
    this.cache = {};
  }
  InMemoryCache.prototype.set = function (key, config) {
    this.cache[key] = config;
  };
  InMemoryCache.prototype.get = function (key) {
    return this.cache[key];
  };
  return InMemoryCache;
}();
export { InMemoryCache };